module.exports = __webpack_public_path__ + "img/img1.2cbbd50c.svg";